import type { User } from '../api/types';

/** Banner presets; the server accepts exactly these keys, and global.css draws them (.profile-cover[data-cover]). */
export const COVERS = ['meadow', 'ocean', 'sunset', 'dusk', 'rose', 'slate', 'aurora', 'sand'] as const;
export type Cover = (typeof COVERS)[number];

/** A small stable number for a string, so each person gets the same default colours every time. */
export function hashOf(seed: string): number {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
  return h >>> 0;
}

/** The banner a person chose, or one picked from their id so nobody starts with an empty header. */
export function coverFor(u: Pick<User, 'id' | 'cover'>): Cover {
  return (COVERS as readonly string[]).includes(u.cover ?? '') ? (u.cover as Cover) : COVERS[hashOf(u.id) % COVERS.length]!;
}

/** Background of a picture-less avatar: a two-tone gradient from the person's id. Dark enough for white initials. */
export function avatarGradient(seed: string): string {
  const hue = hashOf(seed) % 360;
  return `linear-gradient(135deg, hsl(${hue} 62% 42%), hsl(${(hue + 42) % 360} 66% 33%))`;
}
